import rootElementWrapper from './rootElementWrapper';
export const wrapRootElement = rootElementWrapper;
